import { logWrapper } from '../../utils';
import { resolveReferences } from '../../utils';

export default {
  listCrudService: [
    'runtimeConstant',
    '$http',
    '$q',
    '$filter',
    'webApiSettings',
    'listModel',
    function (runtimeConstant, $http, $q, $filter, webApiSettings, List) {
      'use strict';

      function handleError(err, status) {
        if (status === 404 || status === -1) {
          return {
            status_code: status,
            title: $filter('translate')('SERVER OFFLINE'),
            text: $filter('translate')('SERVER OFFLINE MESSAGE'),
          };
        }

        if (status === 400 && err.ModelState) {
          return {
            title: $filter('translate')('ERROR'),
            text: $filter('translate')('VERIFY FIELD ERRORS'),
            modelState: err.ModelState,
          };
        }

        return {
          title: $filter('translate')('ERROR'),
          text: $filter('translate')('ERROR SAVE ROLE'),
        };
      }

      function sortColumns() {
        return [
          { column: 'name', title: 'NAME', type: 'text', sortOrder: 'asc' },
        ];
      }

      function extraActions() {
        var deferred = $q.defer();
        deferred.resolve([]);
        return deferred.promise;
      }

      function listFilters() {
        var deferred = $q.defer();
        var filters = null;
        deferred.resolve(filters);
        return deferred.promise;
      }

      function list() {
        var deferred = $q.defer();
        var url = 'lists';

        $http.get(webApiSettings.apiServiceBaseUri + url).then(
          function (res) {
            var data = res.data;
            var result = [];

            data = resolveReferences(data);

            for (var i = 0; i < data.length; i++) {
              result.push(new List(data[i]));
            }

            deferred.resolve(result);
          },
          function (err) {
            var error = handleError(err.data, err.status);
            deferred.reject(error);
          }
        );

        return deferred.promise;
      }

      function load(id) {
        var deferred = $q.defer();

        var role = new List();

        if (id) {
          $http
            .get(webApiSettings.apiServiceBaseUri + 'lists/' + id, {
              ignoreLoadingBar: true,
            })
            .then(
              function (result) {
                var data = result.data;
                data = resolveReferences(data);
                role = new List(data);
                deferred.resolve(role);
              },
              function (err) {
                deferred.reject({ error: err.data, status: err.status });
              }
            );
        } else {
          deferred.resolve(role);
        }

        return deferred.promise;
      }

      function save(list) {
        var deferred = $q.defer();

        list.items = list.itemsArray;

        if (list.id === 0) {
          $http
            .post(webApiSettings.apiServiceBaseUri + 'lists', list, {
              ignoreLoadingBar: true,
            })
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        } else {
          $http
            .put(webApiSettings.apiServiceBaseUri + 'lists', list, {
              ignoreLoadingBar: true,
            })
            .then(
              function () {
                deferred.resolve();
              },
              function (err) {
                deferred.reject(handleError(err.data, err.status));
              }
            );
        }

        return deferred.promise;
      }

      function _delete(itens) {
        var deferred = $q.defer();

        var ids = [];
        for (var j = 0; j < itens.length; j++) {
          ids.push(itens[j].id);
        }
        $http
          .post(webApiSettings.apiServiceBaseUri + 'lists/removelist', ids)
          .then(
            function () {
              deferred.resolve(true);
            },
            function (err) {
              if (err.data.ModelState) {
                if (err.data.ModelState.DataList) {
                  deferred.reject({
                    title: $filter('translate')('ERROR ON DELETE'),
                    text: err.data.ModelState.DataList[0],
                  });
                }
              }

              deferred.reject(handleError(err.data, err.status));
            }
          );

        return deferred.promise;
      }

      function run() {
        try {
          var listCrudFactory = {};

          listCrudFactory.sortColumns = logWrapper(
            sortColumns,
            runtimeConstant.isDebugServicesInternals
          );
          listCrudFactory.extraActions = logWrapper(
            extraActions,
            runtimeConstant.isDebugServicesInternals
          );
          listCrudFactory.listFilters = logWrapper(
            listFilters,
            runtimeConstant.isDebugServicesInternals
          );
          listCrudFactory.list = logWrapper(
            list,
            runtimeConstant.isDebugServicesInternals
          );
          listCrudFactory.load = logWrapper(
            load,
            runtimeConstant.isDebugServicesInternals
          );
          listCrudFactory.save = logWrapper(
            save,
            runtimeConstant.isDebugServicesInternals
          );
          listCrudFactory.delete = logWrapper(
            _delete,
            runtimeConstant.isDebugServicesInternals
          );

          return listCrudFactory;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugServices)();
    },
  ],
};
